import styled from "styled-components";
import { Div, Img } from "components";
import { Grid, Typography } from "@mui/material";
import { rgba } from "polished";
import QrCodeIcon from "@mui/icons-material/QrCode";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

export const Wrapper = styled(Div)`
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  padding: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: black;
`;

export const WrapperGrid = styled(Grid)`
  && {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const FirstRow = styled(Grid)`
  && {
    display: flex;
    justify-content: space-between;
    background-color: black;
    color: white;
  }
`;

export const SecondRow = styled(Grid)`
  && {
    display: flex;
  }
`;

export const Title = styled(Typography)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 24px;
    font-weight: 600;
    color: white;
  }
`;

export const Message = styled(Typography)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 16px;
    font-weight: 400;
    color: white;
  }
`;

export const NavLeft = styled(Grid)`
  && {
    display: flex;
    flex-direction: row;
  }
`;

export const NavRight = styled.ul`
  display: flex;
  list-style-type: none;
  border: 1px solid ${({ theme }) => theme.colors.gray[theme.borders[0]]};
`;

export const StyledImg = styled(Img)`
  margin-right: 8px;
  margin-left: 0;
`;

export const STypography = styled(Typography)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 14px;
    font-weight: 400;
    margin-left: 10px;
  }
`;

export const SBold = styled(Typography)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.gray[4]};
    margin-left: 10px;
  }
`;

export const SContainer = styled(Grid)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    min-width: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: white;
    cursor: pointer;
    margin-left: 8px;
    border-radius: 4px;
    padding: 0 12px;
    transition: background-color 0.2s ease-in-out;

    &:hover {
      background-color: rgb(77, 81, 84);
      border-color: rgb(77, 81, 84);

      color: ${({ theme }) => theme.textColors.secondary.color};
    }
  }
`;

export const QRCodeIcon = styled(QrCodeIcon)`
  && {
  }
`;

export const CopyContentIcon = styled(ContentCopyIcon)`
  && {
  }
`;

export const BaseDateCalendarIcon = styled(CalendarTodayOutlinedIcon)`
  && {
    color: ${({ theme }) => theme.colors.gray[4]};
  }
`;
